var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CIcon',{class:_vm.iconClass,attrs:{"name":_vm.value ? 'cil-check' : 'cil-x',"size":"lg"}})}
var staticRenderFns = []

export { render, staticRenderFns }